// extracted by mini-css-extract-plugin
export var typingIndicator = "_ns-0";